import get from 'lodash/get'
import { useContext } from 'react'
import useSWR from 'swr'

import { ShippingOptionProps } from '@Components/Shipping/ShippingInfoModal/Options'
import { MetadataContext } from '@Globals/Metadata'

const fetcher = async (
  input: RequestInfo,
  init?: RequestInit,
): Promise<ShippingOptionProps[] | null> => {
  const res = await fetch(input, init)

  const json = await res.json()

  return get(json, 'deliveryInfo', [])
}

interface UseShippingLabelsProps {
  load?: boolean
}

const useShippingLabels = ({ load = true }: UseShippingLabelsProps = {}) => {
  const { storeURL } = useContext(MetadataContext)
  const url = storeURL('pakkelabels/info', new URLSearchParams({ output: 'json' }))
  return useSWR(load && url, fetcher, {
    revalidateOnFocus: false,
  })
}

export default useShippingLabels
